import { Component, OnInit } from '@angular/core';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
export class CustomModalContext extends BSModalContext {
  public modalData: any;
}

@Component({
  selector: 'app-info-popup',
  templateUrl: './info-popup.component.html',
  styleUrls: ['./info-popup.component.css'],
  providers: [Modal]
})
export class InfoPopupComponent implements OnInit,  ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  _this;
  modalData: any;
  constructor( private router: Router,public dialog: DialogRef<CustomModalContext>, private modal: Modal) {
    this.context = this.dialog.context;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
  }

  ngOnInit() {
    this.modalData = this.context.modalData;
  }
  No() {
    this.dialog.context.modalData.next = 'no';
    this.dialog.close();
  }
  Yes() {
    this.dialog.context.modalData.next = 'yes';
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_directive/info-popup/info-popup.component.ts